import { render, staticRenderFns } from "./manybo-pageHeader.vue?vue&type=template&id=328e2ced&scoped=true"
import script from "./manybo-pageHeader.vue?vue&type=script&lang=js"
export * from "./manybo-pageHeader.vue?vue&type=script&lang=js"
import style0 from "./manybo-pageHeader.vue?vue&type=style&index=0&id=328e2ced&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e2ced",
  null
  
)

export default component.exports